export default "__VITE_ASSET__B2_sI1_R__"